var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"fixed","left":"100%","top":"0"}},[_c('input',{ref:"file",attrs:{"type":"file","accept":_vm.accept,"multiple":_vm.multiple},on:{"change":_vm.uploadHandle}})])
}
var staticRenderFns = []

export { render, staticRenderFns }